import Styled from 'styled-components';
import { respondTo } from '@/respondTo';
import { Button } from "@mui/material";

export const P = Styled.h6`
            ${respondTo.tablet_landscape_s`
            padding: 0rem 2.5rem 0.93rem 1.25rem;
               
            `}

            ${respondTo.desktop_xl`
            padding: 0 1.25rem 1.25rem;
            `}
    `;

export const SlideBox = Styled.div`
    position: relative;
    min-width: 16.1875rem ;
    background-color: var(--inverse-on-surface-light);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center; 
    width: 100%;
    overflow-y: hidden;
    height: 415px;

    ${respondTo.tablet_landscape_s`
        min-width: 405px;
        height:  554px;
    `}

    ${respondTo.desktop_xl`
        min-width: 444px;
        height: 604px;
    `}  
  
    `;

export const ImgCardContainer = Styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 70%;
    background-color: var(--inverse-on-surface-light);

    ${respondTo.tablet_landscape_s`
        height: 65%;
    `}
    `;

export const CardDetails = Styled.div<{active ? : boolean}>`
position: relative;
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: flex-start;
width: 100%;
height: 100%;
min-height: 415px; 
transform: ${({ active }) => active ?  "translateY(-68%)" : "translateY(0%)"};
transition: all .3s;
background-color: ${({ active }) => active ? "var(--primary-container-dark)" : "var(--osuface-95)"};
padding: 0.625rem 1.25rem ;
gap :0.625rem;
cursor: pointer;

h2 {
    color: ${({ active }) => active ?  "var(--primary-dark)" : "var(--on-surface-light)"};
}
p {
    color: ${({ active }) => active ?  "var(--on-surface-dark)" : "var(--on-surface-light)"};
}


${respondTo.tablet_landscape_s`
    min-height: 560px;
    transform: ${({ active }:any) => active ? "translateY(-63%)" : "translateY(0%)"};
    :hover {
        background-color: var(--primary-container-dark);
        color: var(--on-surface-dark);

        h2 {
            color: var(--primary-dark);
        }
        p {
            color: var(--on-surface-dark);
        }
    }
`}

${respondTo.desktop_xl`
    min-height:  612px; !important;
    transform: ${({ active }:any) => active ? "translateY(-65%)" : "translateY(0%)"};
`} 
`;

export const Subtitle = Styled.p`
    display: flex;
    text-align: flex-start;
`;



export const HeaderBox = Styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    ${respondTo.tablet_portrait`
        padding:  0.625rem 0;
    `}
`;

export const DescriptionCard = Styled.p<{active ? : boolean}>`
    padding: ${({ active }) => active ? "0rem 0 0.625rem 0" :"5rem 0 0.625rem 0"};
    ${respondTo.tablet_landscape_s`
        padding: ${({ active }:any) => active ? "0rem 0 0.625rem 0" :"8rem 0 0.625rem 0"};
    `}

    ${respondTo.desktop_xl`
        padding: ${({ active }:any) => active ? "0rem 0 0.625rem 0" :"8rem 0 0.625rem 0"};
    `} 
    `;

export const IconImg = Styled.img`
    height: 1.5rem;
    margin-right: 0rem;
    object-fit: contain;
    width: 1.5rem;
    ${respondTo.tablet_landscape_s`
    height: 2rem;
    width: 2rem;
    `}
`;


export const ItemBox =  Styled.div`
align-items: center;
display: flex;
flex-direction: row;
justify-content: flex-start;
align-items: baseline;
width: 100%;
padding:0;
row-gap: 0.625rem;
column-gap: 0.625rem;
align-items: center;

${respondTo.tablet_portrait`
padding: 0.625rem 0 0 0;
row-gap: 0.625rem;
`}


${respondTo.tablet_landscape_s`
padding: 1.25rem 0 0 0;
row-gap: 1.25rem;
`}
`;

export const Btn = Styled(Button)`
     position: absolute;
     bottom:0.375rem;
     right:0.625rem;
     display: flex;
     text-transform: none;
     border-radius: 100px;
     pointer-events: auto !important;
     
 
     svg {
         padding-left:0.2rem;
     }
     ${respondTo.tablet_landscape_s`
         right: 1.25rem;
     `}
     `;


export const CustomImg = Styled.div<{ small? : boolean }>`
    display: ${({ small }) => small ? "block" : "none"};
    min-height: 17.6875rem;
    width: 100%;
    position: relative; 


    ${respondTo.tablet_landscape_s`
    min-height: 21.89rem;
    width: 100%;
    display: ${({ small } : any) => small ===false  ? "block" : "none" };
    `}

${respondTo.desktop_xl`
    min-height: 24.375rem;
    width: 100%;
    `}

    `;

    